import { useState, useEffect, useCallback, useRef } from 'react';

export default function useMouseParallax(intensity = 0.3) {
  const mouse = useRef({ x: 0, y: 0 });
  const smoothed = useRef({ x: 0, y: 0 });
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    setIsTouch('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  const handleMouseMove = useCallback((e) => {
    mouse.current.x = ((e.clientX / window.innerWidth) * 2 - 1) * intensity;
    mouse.current.y = ((e.clientY / window.innerHeight) * 2 - 1) * intensity;
  }, [intensity]);

  useEffect(() => {
    if (isTouch) return;
    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [handleMouseMove, isTouch]);

  /* Call this inside useFrame to get smoothed values */
  const update = useCallback((delta) => {
    const lerpFactor = 1 - Math.pow(0.01, delta);
    smoothed.current.x += (mouse.current.x - smoothed.current.x) * lerpFactor;
    smoothed.current.y += (mouse.current.y - smoothed.current.y) * lerpFactor;
    return smoothed.current;
  }, []);

  return { parallax: smoothed.current, update, isTouch };
}
